var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2076 45.7924 0 29.5 0C13.2076 0 0 13.2076 0 29.5C0 45.7924 13.2076 59 29.5 59Z",
    fill: "#F7F8FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 30H22.4C22.1792 30 22 30.2016 22 30.45V38.55C22 38.7984 22.1792 39 22.4 39H25.6C25.8208 39 26 38.7984 26 38.55V30.45C26 30.2016 25.8208 30 25.6 30Z",
    fill: "#0F53FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8989 25.6794L32.3605 19.155C32.1856 18.9483 31.8145 18.9483 31.6396 19.155L26.1012 25.6794C25.9904 25.8098 25.9687 25.9886 26.0453 26.1395C26.1224 26.2905 26.2844 26.3862 26.4616 26.3862H29.6924V38.565C29.6924 38.8051 29.8991 39 30.1539 39H33.8462C34.101 39 34.3077 38.8051 34.3077 38.565V26.3862H37.5385C37.7157 26.3862 37.8777 26.2905 37.9543 26.1395C38.0314 25.989 38.0097 25.8098 37.8989 25.6794Z",
    fill: "#0F53FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconB);
export default __webpack_public_path__ + "static/media/IconB.9eac4aa2ca2cf7b0c081236ab9a2e833.svg";
export { ForwardRef as ReactComponent };